export default "__VITE_ASSET__BXT2GxI1__"